import { ApiCore } from '@/services/api/utils/core.js'
import { apiProvider } from '@/services/api/utils/provider.js'
import axios from 'axios'
import { handleResponse, handleError } from '@/services/api/utils/response.js'

const url = 'v1/data-elements'

const api = new ApiCore({
	index: true,
	url: url
})

api.index = (params) => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}/data-dictionary?${params}`)
		.then(handleResponse)
		.catch(handleError);
}

api.indexDetails = (params) => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}/${params}/datafields`)
		.then(handleResponse)
		.catch(handleError);
}

export default api
